export interface FooterLinksInterface {
  jobs: string;
  developers: string;
  developerBlog: string;
  cloverHelp: string;
  contactUs: string;
  deviceSetup: string;
  terms: string;
  privacyPolicy: string;
  appMarketTerms: string;
  appMarketPolicies: string;
  developerAgreement: string;
  developerLegalGuidelines: string;
  facebook: string;
  twitter: string;
  github: string;
  instagram: string;
  youtube: string;
  linkedin: string;
}

export const naFooterLinks = {
  jobs: 'https://www.clover.com/jobs',
  developers: 'https://www.clover.com/developers',
  developerBlog: 'https://medium.com/clover-platform-blog',
  cloverHelp: 'https://www.clover.com',
  contactUs: 'https://www.clover.com/contact',
  deviceSetup: 'https://www.clover.com/setup',
  terms: 'https://www.clover.com/terms',
  privacyPolicy: 'https://www.clover.com/privacy-policy',
  appMarketTerms: 'https://www.clover.com/app-market-terms',
  appMarketPolicies: 'https://www.clover.com/app-market-policies',
  developerAgreement: 'https://www.clover.com/developer-agreement',
  developerLegalGuidelines: 'https://www.clover.com/legal-guidelines',
  facebook: 'https://facebook.com/CloverNetworkInc',
  twitter: 'https://twitter.com/cloverpos',
  github: 'https://github.com/clover',
  instagram: 'https://www.instagram.com/clovercommerce/',
  youtube: 'https://www.youtube.com/c/clover/featured',
  linkedin: 'https://www.linkedin.com/company/clovernetwork',
};

export const euFooterLinks = {
  jobs: 'https://www.eu.clover.com/jobs',
  developers: 'https://www.eu.clover.com/developers',
  developerBlog: 'https://medium.com/clover-platform-blog',
  cloverHelp: 'https://www.eu.clover.com',
  contactUs: 'https://www.eu.clover.com/contact',
  deviceSetup: 'https://www.eu.clover.com/setup',
  terms: 'https://www.eu.clover.com/terms',
  privacyPolicy: 'https://www.eu.clover.com/privacy-policy',
  appMarketTerms: 'https://www.eu.clover.com/app-market-terms',
  appMarketPolicies: 'https://www.eu.clover.com/app-market-policies',
  developerAgreement: 'https://www.eu.clover.com/developer-agreement',
  developerLegalGuidelines: 'https://www.eu.clover.com/legal-guidelines',
  facebook: 'https://facebook.com/CloverNetworkInc',
  twitter: 'https://twitter.com/cloverpos',
  github: 'https://github.com/clover',
  instagram: 'https://www.instagram.com/clovercommerce/',
  youtube: 'https://www.youtube.com/c/clover/featured',
  linkedin: 'https://www.linkedin.com/company/clovernetwork',
};

export const laFooterLinks = {
  jobs: 'https://www.la.clover.com/jobs',
  developers: 'https://www.la.clover.com/developers',
  developerBlog: 'https://medium.com/clover-platform-blog',
  cloverHelp: 'https://www.la.clover.com',
  contactUs: 'https://www.la.clover.com/contact',
  deviceSetup: 'https://www.la.clover.com/setup',
  terms: 'https://www.la.clover.com/terms',
  privacyPolicy: 'https://www.la.clover.com/privacy-policy',
  appMarketTerms: 'https://www.la.clover.com/app-market-terms',
  appMarketPolicies: 'https://www.la.clover.com/app-market-policies',
  developerAgreement: 'https://www.la.clover.com/developer-agreement',
  developerLegalGuidelines: 'https://www.la.clover.com/legal-guidelines',
  facebook: 'https://facebook.com/CloverNetworkInc',
  twitter: 'https://twitter.com/cloverpos',
  github: 'https://github.com/clover',
  instagram: 'https://www.instagram.com/clovercommerce/',
  youtube: 'https://www.youtube.com/c/clover/featured',
  linkedin: 'https://www.linkedin.com/company/clovernetwork',
};
